export const formatDate = (dateString: string) => {
  const d = new Date(dateString);
  return d.toLocaleDateString("ar-SA");
};

export const formatTime = (dateString: string) => {
  const d = new Date(dateString);
  return d.toLocaleTimeString("ar-SA", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
